function SortByText (name) {
  return function (a, b) {
    const nameA = a[name].toUpperCase(); // ignore upper and lowercase
    const nameB = b[name].toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  }
}

function SortByNumber (number) {
  return (a, b) => a[number] - b[number]
}

function SortByTextAndNumber(name, number){
  return function (a, b) {
    if(!a[number]){
      const nameA = a[name].toUpperCase(); // ignore upper and lowercase
      const nameB = b[name].toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    }
    else{
      return  a[number] - b[number]
    }
  }
}

module.exports = {
  SortByText,
  SortByNumber,
  SortByTextAndNumber
}
